import { IncomingMessage } from 'http';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import type { ComponentPricing } from '@/payload-types';

import { authHeaders, PayloadSDK } from './PayloadSDK';

class DistributorPriceService {
    static swr = {
        product: (componentId: string) => `/api/distributor-prices/for-product/${componentId}`,
        products: (componentIds: string[]) => `/api/distributor-prices/for-products/${componentIds.join(',')}`,
    };

    static findForProduct = async (componentId: string): Promise<ComponentPricing | null> => {
        const response = await PayloadSDK.find({
            collection: 'componentPricing',
            where: { component: { equals: componentId } },
            depth: 1,
            limit: 1,
            sort: 'price',
        });

        return response.docs[0] ?? null;
    };

    static getMultiple = async (componentIds: string[]) =>
        PayloadSDK.find({
            collection: 'componentPricing',
            where: { component: { in: componentIds } },
            depth: 1,
            pagination: false,
        }).then((response) => response.docs);

    /** A component can be stocked by several distributors; a card shows the cheapest. */
    static cheapestFirstByComponent = (prices: ComponentPricing[]) => {
        const pricesByComponent = new Map<string, ComponentPricing[]>();

        for (const price of [...prices].sort((first, second) => first.price - second.price)) {
            const componentId = CollectionHelpers.id(price.component);

            if (componentId) {
                pricesByComponent.set(componentId, [...(pricesByComponent.get(componentId) ?? []), price]);
            }
        }

        return pricesByComponent;
    };

    static findAllForDistributor = async (
        distributorId: string,
        req?: IncomingMessage,
    ): Promise<ComponentPricing[]> => {
        const response = await PayloadSDK.find(
            {
                collection: 'componentPricing',
                where: { distributor: { equals: distributorId } },
                depth: 0,
                pagination: false,
                sort: '-updatedAt',
            },
            { headers: authHeaders(req) },
        );

        return response.docs;
    };
}

export { DistributorPriceService };
